import { returnErrorWithEmptyPayload, returnNoErrorWithPayload } from './model/model';
const LICENSE_INVALID_RESPONSE = { hasError: true, statusCode: 400, errorMessage: 'license invalid', payload: null, errorId: 'LCNSERR_7734873' };
var LicenseOverride;
(function (LicenseOverride) {
    LicenseOverride["ACTIVE"] = "active";
    LicenseOverride["INACTIVE"] = "inactive";
})(LicenseOverride || (LicenseOverride = {}));
export class DefaultLicenseService {
    enforceValidLicense(context) {
        // https://developer.atlassian.com/platform/marketplace/listing-forge-apps/
        // Check for an environment variable that overrides the license state
        //
        // export FORGE_USER_VAR_LICENSE_OVERRIDE=inactive && forge tunnel
        //  forge variables set -e development LICENSE_OVERRIDE active
        //
        // normal code:
        let isLicenseValid = context && context.license && context.license.isActive;
        if (process && process.env) {
            const override = process.env.LICENSE_OVERRIDE;
            if (typeof override !== 'undefined') {
                if (override.toLowerCase() === LicenseOverride.ACTIVE) {
                    isLicenseValid = true;
                }
                else if (override.toLowerCase() === LicenseOverride.INACTIVE) {
                    isLicenseValid = false;
                }
            }
        }
        // console.log('LICENSE SERVICE >> is license active? ', isLicenseValid);
        if (isLicenseValid) {
            return returnNoErrorWithPayload(null);
        }
        else {
            return returnErrorWithEmptyPayload(LICENSE_INVALID_RESPONSE);
        }
    }
}
